<div
  class="row"
  [formGroup]="filterForm"
  [ngClass]="{
    roadmap: tab_selected === 'roadmap',
    backlog: tab_selected === 'backlog',
    loading: loading,
  }"
>
  <!-- <div class="col-12">
    <div id="filters" class="card">
      <mat-button-toggle-group formControlName="route" style="margin-left: auto;">
        <mat-button-toggle value="backlog">Backlog</mat-button-toggle>
        <mat-button-toggle value="roadmap">Roadmap</mat-button-toggle>
      </mat-button-toggle-group>
    </div>
  </div> -->
  <div class="col-12">
    @if (tab_selected === 'roadmap') {
      <button
        mat-icon-button
        class="small-icon-button roadmap-context-menu-button"
        [matMenuTriggerFor]="roadmapOptionsMenu"
        [matTooltip]="'Opciones del roadmap'"
      >
        <span class="roadmap-context-menu-dots">
          <mat-icon>more_vert</mat-icon>
        </span>
      </button>
      <mat-menu #roadmapOptionsMenu="matMenu" panelClass="roadmap-options-menu-panel">
        <div class="roadmap-context-menu-content" (click)="$event.stopPropagation()">
          <mat-slide-toggle [checked]="show_epics_only" (change)="onEpicsToggleChange($event.checked)" (click)="$event.stopPropagation()">
            Solo epics
          </mat-slide-toggle>
        </div>
        <button mat-menu-item (click)="downloadRoadmapAsExcel()">
          <mat-icon>file_download</mat-icon>
          <span>Exportar excel</span>
        </button>
      </mat-menu>
    }
    <div class="bisual-table-container" cdkScrollable (scroll)="onScrollTable($event)" #scrollContainer>
      <table
        mat-table
        #table
        [dataSource]="dataSource"
        recycleRows
        cdkDropList
        [cdkDropListDisabled]="tab_selected === 'roadmap' && show_epics_only"
        [cdkDropListAutoScrollStep]="8"
        (cdkDropListDropped)="dropped($event)"
        [cdkDropListData]="dataSource.data"
      >
        <!-- DRAGNDROP -->
        <ng-container matColumnDef="dragndrop_head1">
          <th mat-header-cell *matHeaderCellDef [attr.colspan]="6 + task_budgets_column_count" style="text-align: right">Inicio</th>
        </ng-container>
        <ng-container matColumnDef="dragndrop_head2">
          <th mat-header-cell *matHeaderCellDef [attr.colspan]="6 + task_budgets_column_count" style="text-align: right">Fin</th>
          <!-- Final board -->
        </ng-container>
        <ng-container matColumnDef="dragndrop_head3">
          <th mat-header-cell *matHeaderCellDef [attr.colspan]="6 + task_budgets_column_count" style="text-align: right">Tablero</th>
          <!-- Board name -->
        </ng-container>
        <ng-container matColumnDef="dragndrop">
          <th mat-header-cell *matHeaderCellDef>
            @if (tab_selected === 'roadmap') {
              <button
                mat-icon-button
                class="small-icon-button"
                [matTooltip]="'Cargar del pasado...'"
                (click)="loadRoadmapPast()"
                [disabled]="loading"
              >
                <mat-icon>west</mat-icon>
              </button>
            }
          </th>
          <td mat-cell tabindex="0" *matCellDef="let task; let i = index">
            @if (task.id && task.can_edit) {
              <mat-icon style="cursor: grab; vertical-align: middle" cdkDragHandle>drag_indicator</mat-icon>
            }
          </td>
        </ng-container>

        <!-- SELECT -->
        <ng-container matColumnDef="select_head1">
          <ng-container mat-header-cell *matHeaderCellDef></ng-container>
        </ng-container>
        <ng-container matColumnDef="select_head2">
          <ng-container mat-header-cell *matHeaderCellDef></ng-container>
        </ng-container>
        <ng-container matColumnDef="select_head3">
          <ng-container mat-header-cell *matHeaderCellDef></ng-container>
        </ng-container>
        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef>
            <button mat-icon-button class="small-icon-button" [matMenuTriggerFor]="menu">
              <mat-icon>keyboard_arrow_down</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button mat-menu-item (click)="unselectAll()">
                <mat-icon>check_box_outline_blank</mat-icon>
                <span>Deseleccionar ({{ selected_task_idxs.length }})</span>
              </button>
              <mat-divider></mat-divider>
              <button mat-menu-item>
                <mat-icon>new_releases</mat-icon>
                <span>Activar modo borrador ({{ selected_task_idxs.length }})</span>
              </button>
              <button mat-menu-item>
                <mat-icon>verified</mat-icon>
                <span>Desactivar modo borrador ({{ selected_task_idxs.length }})</span>
              </button>
              <mat-divider></mat-divider>
              <button mat-menu-item>
                <mat-icon>archive</mat-icon>
                <span>Archivar ({{ selected_task_idxs.length }})</span>
              </button>
              <button mat-menu-item>
                <mat-icon>unarchive</mat-icon>
                <span>Desarchivar ({{ selected_task_idxs.length }})</span>
              </button>
              <button mat-menu-item color="red">
                <mat-icon>delete</mat-icon>
                <span>Eliminar ({{ selected_task_idxs.length }})</span>
              </button>
            </mat-menu>
          </th>
          <td
            mat-cell
            tabindex="0"
            *matCellDef="let task; let i = index"
            (focus)="onFocus(i, $event)"
            (blur)="onBlur(i, $event, 'selected')"
            (keydown)="onKeydown(i, $event, 'selected', 'selected')"
          >
            <mat-checkbox [checked]="task.selected" (change)="onSelectTask(i, $event.checked)"></mat-checkbox>
          </td>
        </ng-container>

        <!-- EPIC -->
        <ng-container matColumnDef="company_product_epic_id_head1">
          <ng-container mat-header-cell *matHeaderCellDef></ng-container>
        </ng-container>
        <ng-container matColumnDef="company_product_epic_id_head2">
          <ng-container mat-header-cell *matHeaderCellDef></ng-container>
        </ng-container>
        <ng-container matColumnDef="company_product_epic_id_head3">
          <ng-container mat-header-cell *matHeaderCellDef></ng-container>
        </ng-container>
        <ng-container matColumnDef="company_product_epic_id">
          <th mat-header-cell *matHeaderCellDef>Epic</th>
          <td
            mat-cell
            tabindex="0"
            *matCellDef="let task; let i = index"
            class="focusable"
            (focus)="onFocus(i, $event)"
            (blur)="onBlur(i, $event, 'company_product_epic_id')"
            (keydown)="onKeydown(i, $event, 'company_product_epic_id', 'company_product_epic_id')"
          >
            <mat-select
              [panelClass]="'companyProductPhaseBacklogSelectorMinWidthHigher'"
              [value]="task.company_product_epic_id"
              (selectionChange)="onProductTaskCustomAttributeUpdate(i, $event.value, 'company_product_epic_id')"
              #selectorCompanyProductEpic
              [disabled]="!task.can_edit"
            >
              <mat-select-trigger>
                <img [src]="'assets/img/icons/epic_icon.svg'" />
                @if (task.company_product_epic) {
                  {{ task.company_product_epic.name }}
                } @else {
                  Sin Epic
                }
              </mat-select-trigger>

              @if (task.company_product_epic_id) {
                <mat-option
                  (click)="
                    $event.preventDefault();
                    $event.stopPropagation();
                    onProductTaskCustomAttributeUpdate(i, null, 'company_product_epic_id')
                  "
                >
                  <mat-icon>delete</mat-icon>
                  Quitar Epic...
                </mat-option>
              }
              <mat-option (click)="$event.preventDefault(); $event.stopPropagation(); onClickCreateNewEpic(i)">
                <mat-icon>add</mat-icon>
                Crear nuevo Epic...
              </mat-option>

              @if (company_product_epics.length > 0) {
                <mat-divider></mat-divider>
              }
              @for (epic of company_product_epics; track epic) {
                <mat-option [value]="epic.id">
                  <img [src]="'assets/img/icons/epic_icon.svg'" />
                  {{ epic.name }}
                </mat-option>
              }
            </mat-select>
          </td>
        </ng-container>

        <!-- TYPE -->
        <ng-container matColumnDef="type_head1">
          <ng-container mat-header-cell *matHeaderCellDef></ng-container>
        </ng-container>
        <ng-container matColumnDef="type_head2">
          <ng-container mat-header-cell *matHeaderCellDef></ng-container>
        </ng-container>
        <ng-container matColumnDef="type_head3">
          <ng-container mat-header-cell *matHeaderCellDef></ng-container>
        </ng-container>
        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef>
            {{ tab_selected === 'backlog' ? 'Tipo' : '' }}
          </th>
          <td
            mat-cell
            tabindex="0"
            *matCellDef="let task; let i = index"
            class="focusable"
            [ngClass]="task.type"
            (focus)="onFocus(i, $event)"
            (blur)="onBlur(i, $event, 'type')"
            (keydown)="onKeydown(i, $event, 'type', 'type')"
          >
            <mat-select
              [panelClass]="'companyProductPhaseBacklogSelectorMinWidthHigher'"
              [value]="task.type"
              (selectionChange)="onProductTaskCustomAttributeUpdate(i, $event.value, 'type')"
              #selectorType
              [disabled]="!task.can_edit || tab_selected === 'roadmap' || task.id !== null"
            >
              <mat-select-trigger>
                <img [src]="task.type_image_url" />
                @if (tab_selected === 'backlog') {
                  {{ task.type }}
                }
              </mat-select-trigger>
              <mat-option [value]="'story'" [matTooltip]="'story' | productTaskTypeDescriptionPipe">
                <img [src]="'assets/img/icons/story_icon.svg'" />
                Story
              </mat-option>
              <mat-option [value]="'task'">
                <img [src]="'assets/img/icons/task_icon.svg'" />
                Task
              </mat-option>
              <mat-option [value]="'issue'" [matTooltip]="'issue' | productTaskTypeDescriptionPipe">
                <img [src]="'assets/img/icons/issue_icon.svg'" />
                Issue
              </mat-option>
            </mat-select>
          </td>
        </ng-container>

        <!-- IS DRAFT -->
        <ng-container matColumnDef="is_draft_or_archived_head1">
          <ng-container mat-header-cell *matHeaderCellDef></ng-container>
        </ng-container>
        <ng-container matColumnDef="is_draft_or_archived_head2">
          <ng-container mat-header-cell *matHeaderCellDef></ng-container>
        </ng-container>
        <ng-container matColumnDef="is_draft_or_archived_head3">
          <ng-container mat-header-cell *matHeaderCellDef></ng-container>
        </ng-container>
        <ng-container matColumnDef="is_draft_or_archived">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell tabindex="0" *matCellDef="let task; let i = index">
            @if (task.is_archived) {
              <span class="circular-badge blue" [matTooltip]="'Archivada'">
                <mat-icon>archive</mat-icon>
              </span>
            } @else if (task.is_draft) {
              <span class="circular-badge yellow" [matTooltip]="'En borrador'">
                <mat-icon>assignment</mat-icon>
              </span>
            }
          </td>
        </ng-container>

        <!-- REQUIRES CLIENT APPROVAL ? AND CLIENT HAS APPROVED ? -->
        <ng-container matColumnDef="approval_head1">
          <ng-container mat-header-cell *matHeaderCellDef></ng-container>
        </ng-container>
        <ng-container matColumnDef="approval_head2">
          <ng-container mat-header-cell *matHeaderCellDef></ng-container>
        </ng-container>
        <ng-container matColumnDef="approval_head3">
          <ng-container mat-header-cell *matHeaderCellDef></ng-container>
        </ng-container>
        <ng-container matColumnDef="approval">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell tabindex="0" *matCellDef="let task; let i = index">
            @if (task.requires_client_approval) {
              @if (task.client_has_approved === null) {
                <span class="circular-badge yellow" [matTooltip]="'Requiere aprobación del cliente'">
                  <mat-icon>help</mat-icon>
                </span>
              } @else if (task.client_has_approved === false) {
                <span class="circular-badge red" [matTooltip]="'Declinada'">
                  <mat-icon>thumb_down</mat-icon>
                </span>
              } @else if (task.client_has_approved === true) {
                <span class="circular-badge green" [matTooltip]="'Aprobada'">
                  <mat-icon>thumb_up</mat-icon>
                </span>
              }
            }
          </td>
        </ng-container>

        <!-- CODE -->
        <ng-container matColumnDef="code_head1">
          <ng-container mat-header-cell *matHeaderCellDef></ng-container>
        </ng-container>
        <ng-container matColumnDef="code_head2">
          <ng-container mat-header-cell *matHeaderCellDef></ng-container>
        </ng-container>
        <ng-container matColumnDef="code_head3">
          <ng-container mat-header-cell *matHeaderCellDef></ng-container>
        </ng-container>
        <ng-container matColumnDef="code">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell tabindex="0" *matCellDef="let task; let i = index">
            {{ task.code }}
          </td>
        </ng-container>

        <!-- TITLE -->
        <ng-container matColumnDef="title_head1">
          <ng-container mat-header-cell *matHeaderCellDef></ng-container>
        </ng-container>
        <ng-container matColumnDef="title_head2">
          <ng-container mat-header-cell *matHeaderCellDef></ng-container>
        </ng-container>
        <ng-container matColumnDef="title_head3">
          <ng-container mat-header-cell *matHeaderCellDef></ng-container>
        </ng-container>
        <ng-container matColumnDef="title">
          <th mat-header-cell *matHeaderCellDef>
            @if (tab_selected === 'backlog') {
              Título
            }
          </th>
          <td
            mat-cell
            tabindex="0"
            *matCellDef="let task; let i = index"
            class="focusable"
            (keydown)="onKeydown(i, $event, 'title', 'title')"
            (blur)="onBlur(i, $event, 'title')"
            (focus)="onFocus(i, $event)"
          >
            <input
              matInput
              [value]="task.title"
              (blur)="onBlur(i, $event, 'title')"
              (focus)="onFocus(i, $event)"
              [readonly]="!task.can_edit || task.completed"
            />
          </td>
        </ng-container>

        <!-- DESCRIPTION -->
        <ng-container matColumnDef="description_head1">
          <ng-container mat-header-cell *matHeaderCellDef></ng-container>
        </ng-container>
        <ng-container matColumnDef="description_head2">
          <ng-container mat-header-cell *matHeaderCellDef></ng-container>
        </ng-container>
        <ng-container matColumnDef="description_head3">
          <ng-container mat-header-cell *matHeaderCellDef></ng-container>
        </ng-container>
        <ng-container matColumnDef="description">
          <th mat-header-cell *matHeaderCellDef>Descripción</th>
          <td
            mat-cell
            tabindex="0"
            *matCellDef="let task; let i = index"
            class="focusable"
            (keydown)="onKeydown(i, $event, 'description', 'description')"
            (blur)="onBlur(i, $event, 'description')"
            (focus)="onFocus(i, $event)"
          >
            <div class="description">
              @if (!task.editing_description) {
                <p
                  class="description-preview"
                  [class.description-preview-empty]="!task.description_markdown"
                  (click)="onClickedDescriptionParagraph(i)"
                >
                  {{ task.description_markdown }}
                </p>
                @if (!task.completed && task.can_edit) {
                  <button mat-icon-button class="small-icon-button" (click)="onClickOpenDescription(i)">
                    <mat-icon>arrow_circle_down</mat-icon>
                  </button>
                }
              } @else {
                <editor
                  [apiKey]="tinyMceApiKey"
                  cloudChannel="6"
                  [disabled]="!task.can_edit"
                  [id]="'description-editor-' + (task.id ?? i)"
                  [init]="active_tinymce_init"
                  (onInit)="onEditorInit($event, i)"
                  [initialValue]="task.description"
                  [inline]="false"
                  tagName="div"
                  (onKeyDown)="onKeydownDescription(i, $event)"
                  plugins="anchor autolink charmap codesample directionality help image insertdatetime link lists media nonbreaking pagebreak searchreplace table visualblocks visualchars wordcount advlist autolink lists link image charmap preview anchor searchreplace visualblocks code fullscreen insertdatetime media table emoticons codesample"
                  toolbar="undo redo | bold italic underline strikethrough | align checklist bullist numlist | blocks fontfamily fontsize | removeformat typography"
                ></editor>
                <button mat-icon-button class="small-icon-button" (click)="onClickCloseDescription(i)">
                  <mat-icon>arrow_circle_up</mat-icon>
                </button>
              }
            </div>
          </td>
        </ng-container>

        <!-- IS_HOTFIX -->
        <ng-container matColumnDef="is_hotfix_head1">
          <ng-container mat-header-cell *matHeaderCellDef></ng-container>
        </ng-container>
        <ng-container matColumnDef="is_hotfix_head2">
          <ng-container mat-header-cell *matHeaderCellDef></ng-container>
        </ng-container>
        <ng-container matColumnDef="is_hotfix_head3">
          <ng-container mat-header-cell *matHeaderCellDef></ng-container>
        </ng-container>
        <ng-container matColumnDef="is_hotfix">
          <th mat-header-cell *matHeaderCellDef style="text-align: center">
            <mat-icon style="vertical-align: middle" [matTooltip]="'Es un Hotfix'">local_fire_department</mat-icon>
          </th>
          <td
            mat-cell
            tabindex="0"
            *matCellDef="let task; let i = index"
            class="focusable"
            (focus)="onFocus(i, $event)"
            (blur)="onBlur(i, $event, 'is_hotfix')"
            (keydown)="onKeydown(i, $event, 'is_hotfix', 'is_hotfix')"
          >
            <mat-checkbox
              [disabled]="task.completed || !task.can_edit"
              [checked]="task.is_hotfix"
              (change)="onProductTaskCustomAttributeUpdate(i, $event.checked, 'is_hotfix')"
            ></mat-checkbox>
          </td>
        </ng-container>

        <!-- NEEDS_TESTING -->
        <ng-container matColumnDef="needs_testing_head1">
          <ng-container mat-header-cell *matHeaderCellDef></ng-container>
        </ng-container>
        <ng-container matColumnDef="needs_testing_head2">
          <ng-container mat-header-cell *matHeaderCellDef></ng-container>
        </ng-container>
        <ng-container matColumnDef="needs_testing_head3">
          <ng-container mat-header-cell *matHeaderCellDef></ng-container>
        </ng-container>
        <ng-container matColumnDef="needs_testing">
          <th mat-header-cell *matHeaderCellDef style="text-align: center">
            <mat-icon style="vertical-align: middle" [matTooltip]="'Requiere testing'">troubleshoot</mat-icon>
          </th>
          <td
            mat-cell
            tabindex="0"
            *matCellDef="let task; let i = index"
            class="focusable"
            (focus)="onFocus(i, $event)"
            (blur)="onBlur(i, $event, 'needs_testing')"
            (keydown)="onKeydown(i, $event, 'needs_testing', 'needs_testing')"
          >
            <mat-checkbox
              [disabled]="task.completed || !task.can_edit"
              [checked]="task.needs_testing"
              (change)="onProductTaskCustomAttributeUpdate(i, $event.checked, 'needs_testing')"
            ></mat-checkbox>
          </td>
        </ng-container>

        <!-- HAS_DEADTIME -->
        <ng-container matColumnDef="has_dead_time_head1">
          <ng-container mat-header-cell *matHeaderCellDef></ng-container>
        </ng-container>
        <ng-container matColumnDef="has_dead_time_head2">
          <ng-container mat-header-cell *matHeaderCellDef></ng-container>
        </ng-container>
        <ng-container matColumnDef="has_dead_time_head3">
          <ng-container mat-header-cell *matHeaderCellDef></ng-container>
        </ng-container>
        <ng-container matColumnDef="has_dead_time">
          <th mat-header-cell *matHeaderCellDef style="text-align: center">
            <mat-icon style="vertical-align: middle" [matTooltip]="'Incluir horas muertas'">coffee</mat-icon>
          </th>
          <td
            mat-cell
            tabindex="0"
            *matCellDef="let task; let i = index"
            class="focusable"
            (focus)="onFocus(i, $event)"
            (blur)="onBlur(i, $event, 'has_dead_time')"
            (keydown)="onKeydown(i, $event, 'has_dead_time', 'has_dead_time')"
          >
            <mat-checkbox
              [disabled]="true"
              [checked]="task.has_dead_time"
              (change)="onProductTaskCustomAttributeUpdate(i, $event.checked, 'has_dead_time')"
            ></mat-checkbox>
          </td>
        </ng-container>

        <!-- TIME_AUTOCALC -->
        <ng-container matColumnDef="time_autocalc_head1">
          <ng-container mat-header-cell *matHeaderCellDef></ng-container>
        </ng-container>
        <ng-container matColumnDef="time_autocalc_head2">
          <ng-container mat-header-cell *matHeaderCellDef></ng-container>
        </ng-container>
        <ng-container matColumnDef="time_autocalc_head3">
          <ng-container mat-header-cell *matHeaderCellDef></ng-container>
        </ng-container>
        <ng-container matColumnDef="time_autocalc">
          <th mat-header-cell *matHeaderCellDef>
            <span class="time-autocalc-title">Time</span>
            <span class="time-autocalc-subtitle">Autocalc</span>
            @if (user_permissions().can_edit_backlog) {
              <button mat-icon-button class="small-icon-button" (click)="onClickOpenTimeAutocalcSettings()">
                <mat-icon>settings</mat-icon>
              </button>
            }
          </th>
          <!-- <td mat-cell tabindex="0" *matCellDef="let task; let i = index;" class="focusable"></td> -->
          <td
            mat-cell
            tabindex="0"
            *matCellDef="let task; let i = index"
            class="focusable"
            (keydown)="onKeydown(i, $event, 'time_autocalc', 'time_autocalc')"
            (blur)="onBlur(i, $event, 'time_autocalc')"
            (focus)="onFocus(i, $event)"
          >
            <div class="time_autocalc">
              <input
                rows="1"
                type="text"
                [placeholder]="task.disabled_time_autocalc ? '-' : '0h 0m'"
                class="time-autocalc-input"
                (blur)="onBlur(i, $event, 'time_autocalc')"
                (focus)="onFocus(i, $event)"
                [disabled]="task.completed || !task.can_edit || task.disabled_time_autocalc"
                [matTooltip]="task.disabled_time_autocalc ? 'No se puede propagar el tiempo de una tarea sin desarrollo.' : ''"
              />
            </div>
          </td>
        </ng-container>

        <!-- BUDGETS -->
        <!-- for company_product_default_task_distribution_distributables show ng-container -->
        @for (ppttas of columns; let j = $index; track ppttas) {
          <ng-container [matColumnDef]="ppttas.key + '_head1'">
            <ng-container mat-header-cell *matHeaderCellDef></ng-container>
          </ng-container>
          <ng-container [matColumnDef]="ppttas.key + '_head2'">
            <ng-container mat-header-cell *matHeaderCellDef></ng-container>
          </ng-container>
          <ng-container [matColumnDef]="ppttas.key + '_head3'">
            <ng-container mat-header-cell *matHeaderCellDef></ng-container>
          </ng-container>
          <ng-container [matColumnDef]="ppttas.key">
            <th
              mat-header-cell
              *matHeaderCellDef
              class="time-distribution-column"
              [ngStyle]="{
                left: ppttas.left,
                'text-align': 'center',
              }"
            >
              <mat-icon
                [matTooltip]="ppttas.name"
                [ngStyle]="{
                  'vertical-align': 'center',
                  '-webkit-text-fill-color': ppttas.color,
                }"
              >
                {{ ppttas.icon }}
              </mat-icon>
            </th>
            <td
              mat-cell
              tabindex="0"
              *matCellDef="let task; let i = index"
              class="focusable time-distribution-column"
              (keydown)="onKeydown(i, $event, ppttas.key, ppttas.key)"
              (blur)="onBlur(i, $event, ppttas.key)"
              (focus)="onFocus(i, $event)"
              [ngStyle]="{
                'background-color':
                  task.budgetables.hasOwnProperty(ppttas.key) &&
                  (tab_selected === 'roadmap' || task.budgetables[ppttas.key].in_use_for_autocalc !== false)
                    ? ppttas.background_soft_color
                    : '',
                left: ppttas.left,
              }"
            >
              @if (
                tab_selected === 'backlog' ||
                (!task.completed && (!(ppttas.key in task.budgetables) || task.budgetables[ppttas.key].editing))
              ) {
                <div class="d-flex align-items-center">
                  @if (tab_selected === 'backlog') {
                    <button
                      mat-icon-button
                      class="tiny-icon-button"
                      type="button"
                      (click)="$event.stopPropagation(); changeInUseAttributeFromTaskAndDistribution(i, ppttas)"
                      [disabled]="
                        task.is_archived ||
                        $safeNavigationMigration(task.budgetables[ppttas.key]?.completed_by_user_id) !== null ||
                        !task.can_edit
                      "
                    >
                      <mat-icon
                        [ngStyle]="{
                          '-webkit-text-fill-color': ppttas.key in task.budgetables ? ppttas.color : '',
                        }"
                      >
                        radio_button_checked
                      </mat-icon>
                    </button>
                  }
                  <input
                    class="time-distribution-column"
                    rows="1"
                    type="number"
                    [min]="0"
                    [step]="0.5"
                    [value]="task.budgetables[ppttas.key]?.total_time_budget_in_hours ?? ''"
                    (blur)="onBlur(i, $event, ppttas.key)"
                    (focus)="onFocus(i, $event)"
                    [disabled]="
                      task.completed ||
                      task.is_archived ||
                      $safeNavigationMigration(task.budgetables[ppttas.key]?.completed_by_user_id) !== null ||
                      !task.can_edit
                    "
                  />

                  @if (
                    ppttas.key in task.budgetables &&
                    !task.budgetables[ppttas.key].editing &&
                    task.budgetables[ppttas.key].completed_by_user_id !== null
                  ) {
                    <mat-icon
                      class="completed-check"
                      [matTooltip]="task.completed ? 'Categoría completada (tarea completada)' : 'Clic para marcar como no completada'"
                      [ngStyle]="{ cursor: task.can_edit ? 'pointer' : 'default' }"
                      (click)="task.can_edit && onClickUncompleteBudget(i, ppttas.key)"
                      >check_circle</mat-icon
                    >
                  } @else if (
                    ppttas.key in task.budgetables &&
                    !task.budgetables[ppttas.key].editing &&
                    task.budgetables[ppttas.key].completed_by_user_id === null &&
                    task.budgetables[ppttas.key].product_task_time_budget_id != null &&
                    task.can_edit
                  ) {
                    <mat-icon
                      class="completed-check uncompleted"
                      matTooltip="Clic para marcar como completada"
                      [ngStyle]="{ cursor: 'pointer', opacity: 0.3 }"
                      (click)="onClickCompleteBudget(i, ppttas.key)"
                      >check_circle</mat-icon
                    >
                  }
                </div>
              } @else if (tab_selected === 'roadmap' && task.budgetables.hasOwnProperty(ppttas.key)) {
                <div
                  class="roadmap-budgets three-columns"
                  [ngStyle]="{
                    'background-color': task.budgetables[ppttas.key].background_soft_color,
                    border:
                      '2px solid ' +
                      (task.budgetables[ppttas.key].completed_by_user_id !== null
                        ? 'var(--green)'
                        : task.budgetables[ppttas.key].distributable.color),
                  }"
                  (click)="task.budgetables[ppttas.key].editing = true"
                  (keydown.enter)="task.budgetables[ppttas.key].editing = true"
                >
                  <div class="budget" [matTooltip]="'Tiempo presupuestado'">
                    <span>
                      {{
                        task.budgetables[ppttas.key].total_time_budget_in_hours
                          | number: (task.budgetables[ppttas.key].total_time_budget_in_hours > 1 ? '1.0-0' : '1.0-1')
                      }}
                    </span>
                    <!-- <div class="progress"></div> -->
                  </div>
                  <div class="budget" [matTooltip]="'Tiempo asignado a tableros'">
                    <span>
                      {{
                        task.budgetables[ppttas.key].total_time_assigned_in_hours
                          | number: (task.budgetables[ppttas.key].total_time_assigned_in_hours > 1 ? '1.0-0' : '1.0-1')
                      }}
                    </span>
                    <div
                      class="progress"
                      [ngStyle]="{
                        height:
                          task.budgetables[ppttas.key].total_time_budget_in_hours <= 0
                            ? task.budgetables[ppttas.key].completed_by_user_id !== null
                              ? '100%'
                              : '0%'
                            : (task.budgetables[ppttas.key].total_time_assigned_in_hours /
                                task.budgetables[ppttas.key].total_time_budget_in_hours) *
                                100 +
                              '%',
                        'background-color': task.budgetables[ppttas.key].progress_bar_color,
                      }"
                    ></div>
                  </div>
                  <div class="budget" [matTooltip]="'Tiempo registrado'">
                    <span>
                      {{
                        task.budgetables[ppttas.key].total_time_done_in_hours
                          | number: (task.budgetables[ppttas.key].total_time_done_in_hours > 1 ? '1.0-0' : '1.0-1')
                      }}
                    </span>
                    <div
                      class="progress"
                      [ngStyle]="{
                        height:
                          task.budgetables[ppttas.key].total_time_budget_in_hours <= 0
                            ? task.budgetables[ppttas.key].completed_by_user_id !== null
                              ? '100%'
                              : '0%'
                            : (task.budgetables[ppttas.key].total_time_done_in_hours /
                                task.budgetables[ppttas.key].total_time_budget_in_hours) *
                                100 +
                              '%',
                        'background-color':
                          task.budgetables[ppttas.key].total_time_budget_in_hours === 0 ||
                          task.budgetables[ppttas.key].total_time_done_in_hours <= task.budgetables[ppttas.key].total_time_budget_in_hours
                            ? task.budgetables[ppttas.key].progress_bar_color
                            : '#e86969',
                      }"
                    ></div>
                  </div>

                  @if ($safeNavigationMigration(task.budgetables[ppttas.key]?.completed_by_user_id) !== null) {
                    <mat-icon
                      class="completed-check"
                      [matTooltip]="task.completed ? 'Categoría completada (tarea completada)' : 'Clic para marcar como no completada'"
                      [ngStyle]="{ cursor: task.can_edit ? 'pointer' : 'default' }"
                      (click)="task.can_edit && onClickUncompleteBudget(i, ppttas.key)"
                      >check_circle</mat-icon
                    >
                  }
                </div>
              }
            </td>
          </ng-container>
        }

        <!-- TIME_TOTAL -->
        <ng-container matColumnDef="time_total_head1">
          <ng-container mat-header-cell *matHeaderCellDef></ng-container>
        </ng-container>
        <ng-container matColumnDef="time_total_head2">
          <ng-container mat-header-cell *matHeaderCellDef></ng-container>
        </ng-container>
        <ng-container matColumnDef="time_total_head3">
          <ng-container mat-header-cell *matHeaderCellDef></ng-container>
        </ng-container>
        <ng-container matColumnDef="time_total">
          <th mat-header-cell *matHeaderCellDef>
            <mat-icon style="vertical-align: middle">functions</mat-icon>
          </th>
          <td mat-cell tabindex="0" *matCellDef="let task; let i = index" class="focusable">
            <div class="time_autocalc">
              <input rows="1" type="text" placeholder="x.xx" [value]="task.total_time_in_hours" />
            </div>
          </td>
        </ng-container>

        <!-- ACTIONS -->
        <ng-container matColumnDef="actions_head1">
          <th mat-header-cell *matHeaderCellDef rowspan="4">
            @if (!limit_right_reached) {
              <button mat-icon-button [matTooltip]="'Cargar más a futuro'" (click)="loadRoadmapFuture()" [disabled]="loading">
                <mat-icon>east</mat-icon>
              </button>
            }
          </th>
        </ng-container>
        <ng-container matColumnDef="actions_head2">
          <ng-container mat-header-cell *matHeaderCellDef>
            @if (tab_selected === 'backlog') {
              <th mat-header-cell></th>
            }
          </ng-container>
        </ng-container>
        <ng-container matColumnDef="actions_head3">
          <ng-container mat-header-cell *matHeaderCellDef>
            @if (tab_selected === 'backlog') {
              <th mat-header-cell></th>
            }
          </ng-container>
        </ng-container>
        <ng-container matColumnDef="actions">
          <ng-container mat-header-cell *matHeaderCellDef>
            @if (tab_selected === 'backlog') {
              <th mat-header-cell></th>
            }
          </ng-container>
          <td mat-cell tabindex="0" *matCellDef="let task; let i = index">
            <div class="d-flex align-items-center justify-content-center">
              <button mat-icon-button class="small-icon-button" [matMenuTriggerFor]="menu">
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #menu="matMenu">
                <!-- VER TAREA -->
                @if (task.id > 0) {
                  <button mat-menu-item (click)="openTask(i)">
                    <mat-icon>visibility</mat-icon>
                    <span>Ver tarea</span>
                  </button>
                  @if (user_permissions().can_edit_backlog) {
                    <button mat-menu-item (click)="startManualReorderingForTask(i)">
                      <mat-icon>move_down</mat-icon>
                      Mover tarea...
                    </button>
                  }
                  @if (task.completed && user_permissions().can_edit_backlog) {
                    <button mat-menu-item (click)="openIssueFromTask(i)" color="red">
                      <mat-icon>add_circle</mat-icon>
                      Abrir issue
                    </button>
                  }
                  <mat-divider></mat-divider>
                }

                <!-- SELECCIONAR -->
                @if (task.can_edit) {
                  @if (task.selected) {
                    <button mat-menu-item (click)="onSelectTask(i, false)">
                      <mat-icon>check_box_outline_blank</mat-icon>
                      <span>Deseleccionar</span>
                    </button>
                  } @else {
                    <button mat-menu-item (click)="onSelectTask(i, true)">
                      <mat-icon>check_box</mat-icon>
                      <span>Seleccionar</span>
                    </button>
                  }
                  <mat-divider></mat-divider>
                }

                <!-- BORRADOR -->
                @if (!task.is_archived && user_permissions().can_edit_backlog && !task.completed) {
                  @if (task.is_draft && canPublishTask(task)) {
                    <button mat-menu-item [matTooltip]="'Desactivar el modo borrador.'" (click)="disableDraft(i)">
                      <mat-icon>verified</mat-icon>
                      <span>Marcar como preparada...</span>
                    </button>
                  } @else if (
                    task.is_draft && user_permissions().can_only_create_issues && (task.type === 'story' || task.type === 'task')
                  ) {
                    <button mat-menu-item disabled [matTooltip]="storyTaskPublishRequiresPmTooltip">
                      <mat-icon>verified</mat-icon>
                      <span>Marcar como preparada...</span>
                    </button>
                  } @else {
                    <button mat-menu-item (click)="enableDraft(i)">
                      <mat-icon>new_releases</mat-icon>
                      <span>Marcar como borrador...</span>
                    </button>
                  }
                  <mat-divider></mat-divider>
                }

                <!-- REQUIRES CLIENT APPROVAL -->
                @if (!task.is_archived && !task.completed) {
                  @if (task.requires_client_approval && (isClientBusiness || isClientDeveloper) && !task.is_draft) {
                    <button mat-menu-item (click)="clientApprove(i)">
                      <mat-icon>check</mat-icon>
                      <span>Aceptar tarea</span>
                    </button>
                    <button mat-menu-item (click)="clientDeny(i)">
                      <mat-icon>close</mat-icon>
                      <span>Rechazar tarea</span>
                    </button>
                    <mat-divider></mat-divider>
                  } @else if (user_permissions().can_request_client_approval) {
                    @if (!task.requires_client_approval) {
                      <button mat-menu-item (click)="askClientForApproval(i)">
                        <mat-icon>gavel</mat-icon>
                        <span>
                          {{ task.is_draft ? 'Solicitar aprobación cuando esté preparada...' : 'Solicitar aprobación...' }}
                        </span>
                      </button>
                      <mat-divider></mat-divider>
                    } @else if (task.requires_client_approval && !task.is_draft) {
                      @if (task.client_approval_replied_at === null) {
                        <button mat-menu-item disabled>
                          <mat-icon>gavel</mat-icon>
                          <span>Esperando respuesta...</span>
                        </button>
                        <button mat-menu-item (click)="cancelApprovalRequest(i)">
                          <mat-icon>cancel</mat-icon>
                          <span>Cancelar solicitud de aprobación...</span>
                        </button>
                        <mat-divider></mat-divider>
                      } @else if (task.client_approval_replied_at !== null && !task.client_has_approved) {
                        <button mat-menu-item (click)="reaskClientForApproval(i)">
                          <mat-icon>gavel</mat-icon>
                          <span>Volver a solicitar aprobación...</span>
                        </button>
                        <mat-divider></mat-divider>
                      }
                    }
                  }
                }

                @if (user_permissions().can_edit_backlog && !task.completed && !task.has_time_registered) {
                  <button mat-menu-item (click)="switchTaskToNewPhase(i)">
                    <mat-icon>swap_horiz</mat-icon>
                    <span>Traspasar de fase</span>
                  </button>
                }
                @if (task.can_be_added_to_current_board) {
                  <button mat-menu-item (click)="addTaskToCurrentBoard(i)">
                    <mat-icon>add_to_photos</mat-icon>
                    <span>Añadir al tablero actual</span>
                  </button>
                }
                <!-- ELIMINAR I ARCHIVAR -->
                @if (task.can_archive_or_delete) {
                  @if (task.is_archived) {
                    <button mat-menu-item (click)="unarchiveTask(i)">
                      <mat-icon>unarchive</mat-icon>
                      <span>Desarchivar</span>
                    </button>
                  } @else {
                    <button mat-menu-item (click)="archiveTask(i)">
                      <mat-icon>archive</mat-icon>
                      <span>Archivar</span>
                    </button>
                  }
                  @if (!task.completed) {
                    <button mat-menu-item (click)="deleteTask(i)" color="red">
                      <mat-icon>delete</mat-icon>
                      <span>Eliminar tarea</span>
                    </button>
                  }
                }
              </mat-menu>
            </div>
          </td>
        </ng-container>

        <!-- ROADMAP COLUMNS -->
        @for (item of roadmap_columns_data | keyvalue; let i = $index; track item.key) {
          @for (budgetable of item.value.product_task_board_time_budgets | keyvalue; let j = $index; track budgetable.key) {
            <ng-container [matColumnDef]="item.key + '_' + budgetable.key + '_head1'">
              <ng-container *matHeaderCellDef>
                @if (j === 0 && item.value.product_task_board_time_budgets) {
                  <th
                    mat-header-cell
                    [attr.colspan]="objectKeysFn(item.value.product_task_board_time_budgets).length"
                    [ngClass]="{
                      'border-left': true,
                      'roadmap-col': true,
                      'active-this-week': item.value.active_this_week,
                    }"
                  >
                    {{ item.value.start_date | date: 'shortDate' }}
                  </th>
                }
              </ng-container>
            </ng-container>
            <ng-container [matColumnDef]="item.key + '_' + budgetable.key + '_head2'">
              <ng-container *matHeaderCellDef>
                @if (j === 0 && item.value.product_task_board_time_budgets) {
                  <th
                    mat-header-cell
                    [attr.colspan]="objectKeysFn(item.value.product_task_board_time_budgets).length"
                    [ngClass]="{
                      'border-left': true,
                      'roadmap-col': true,
                      'active-this-week': item.value.active_this_week,
                    }"
                  >
                    {{ item.value.end_date | date: 'shortDate' }}
                  </th>
                }
              </ng-container>
            </ng-container>
            <ng-container [matColumnDef]="item.key + '_' + budgetable.key + '_head3'">
              <ng-container *matHeaderCellDef>
                @if (j === 0 && item.value.product_task_board_time_budgets) {
                  <th
                    mat-header-cell
                    [attr.colspan]="objectKeysFn(item.value.product_task_board_time_budgets).length"
                    [ngClass]="{
                      'border-left': true,
                      'roadmap-col': true,
                      'active-this-week': item.value.active_this_week,
                    }"
                  >
                    {{ item.value.company_product_phase_board?.title }}

                    @if (user_permissions().can_edit_board) {
                      <button mat-icon-button class="setting-button" [matMenuTriggerFor]="menu">
                        <mat-icon>more_vert</mat-icon>
                      </button>
                      <mat-menu #menu="matMenu">
                        @if (item.value.company_product_phase_board) {
                          <button mat-menu-item [routerLink]="['boards', item.value.company_product_phase_board.id]">
                            <mat-icon>visibility</mat-icon>
                            Ver tablero
                          </button>
                          @if (
                            item.value.company_product_phase_board.end_date! > now || item.value.company_product_phase_board.is_deletable
                          ) {
                            @if (item.value.company_product_phase_board.end_date! > now) {
                              <button mat-menu-item (click)="onClickModifyCompanyProductPhaseBoard(item.key)">
                                <mat-icon>edit</mat-icon>
                                <span>Modificar tablero</span>
                              </button>
                              <button mat-menu-item (click)="onClickCompleteCompanyProductPhaseBoard(item.key)">
                                <mat-icon>verified</mat-icon>
                                <span>Completar Sprint</span>
                              </button>
                            }

                            @if (item.value.company_product_phase_board.is_deletable) {
                              <button mat-menu-item color="red" (click)="onClickDeleteCompanyProductPhaseBoard(item.key)">
                                <mat-icon>delete</mat-icon>
                                <span>Eliminar tablero</span>
                              </button>
                            }
                            <mat-divider></mat-divider>
                          }
                        } @else {
                          <button mat-menu-item (click)="onClickCreateCompanyProductPhaseBoard(item.key)">
                            <mat-icon>add_circle</mat-icon>
                            <span>Crear tablero</span>
                          </button>
                          <mat-divider></mat-divider>
                        }
                      </mat-menu>
                    }

                    <!-- Aquí ponemos los MatMenu -->
                  </th>
                }
              </ng-container>
            </ng-container>
            <ng-container [matColumnDef]="item.key + '_' + budgetable.key">
              <th
                mat-header-cell
                *matHeaderCellDef
                [ngClass]="{
                  'border-left': j === 0,
                  'roadmap-col': true,
                  'active-this-week': item.value.active_this_week,
                  completed:
                    item.value.company_product_phase_board &&
                    budgetable.value.total_time_assigned_in_seconds >= budgetable.value.total_time_budget_in_seconds,
                }"
              >
                @if (item.value.employee_calendar_register) {
                  <div
                    class="roadmap-budgets two-columns"
                    [ngStyle]="{
                      'background-color': budgetable.value.background_soft_color,
                      border: '2px solid ' + budgetable.value.distributable.color,
                    }"
                  >
                    <div
                      class="budget"
                      [matTooltip]="
                        'Tiempo disponible de ' +
                        (castToWorkingTimeCategory(budgetable.value.distributable)?.short_name ?? budgetable.value.distributable.name) +
                        ' en sprint'
                      "
                    >
                      <span>
                        {{
                          budgetable.value.total_time_budget_in_hours
                            | number: (budgetable.value.total_time_budget_in_seconds > 1 ? '1.0-0' : '1.0-1')
                        }}
                      </span>
                    </div>
                    <div
                      class="budget"
                      [matTooltip]="
                        'Tiempo previsto en ' +
                        (castToWorkingTimeCategory(budgetable.value.distributable)?.short_name ?? budgetable.value.distributable.name)
                      "
                    >
                      <span>
                        {{
                          budgetable.value.total_time_assigned_in_hours
                            | number: (budgetable.value.total_time_assigned_in_seconds > 1 ? '1.0-0' : '1.0-1')
                        }}
                      </span>
                      <div
                        class="progress"
                        [ngStyle]="{
                          height: (budgetable.value.total_time_assigned_in_hours / budgetable.value.total_time_budget_in_hours) * 100 + '%',
                          'background-color': budgetable.value.progress_bar_color,
                        }"
                      ></div>
                    </div>
                  </div>
                } @else if (item.value.company_product_phase_board) {
                  <div
                    class="roadmap-budgets three-columns"
                    [ngStyle]="{
                      'background-color':
                        budgetable.value.total_time_assigned_in_seconds >= budgetable.value.total_time_budget_in_seconds
                          ? '#dcedd2'
                          : budgetable.value.background_soft_color,
                      border: '2px solid ' + budgetable.value.distributable.color,
                    }"
                  >
                    <div
                      class="budget"
                      [matTooltip]="
                        'Horas presupuestadas en tablero en ' +
                        (castToWorkingTimeCategory(budgetable.value.distributable)?.short_name ?? budgetable.value.distributable.name)
                      "
                    >
                      <span>
                        {{
                          budgetable.value.total_time_budget_in_hours
                            | number: (budgetable.value.total_time_budget_in_seconds > 1 ? '1.0-0' : '1.0-1')
                        }}
                      </span>
                      <!-- <div class="progress"></div> -->
                    </div>
                    <div
                      class="budget"
                      [matTooltip]="
                        'Horas asignadas a tareas en ' +
                        (castToWorkingTimeCategory(budgetable.value.distributable)?.short_name ?? budgetable.value.distributable.name)
                      "
                    >
                      <span>
                        {{
                          budgetable.value.total_time_assigned_in_hours
                            | number: (budgetable.value.total_time_assigned_in_seconds > 1 ? '1.0-0' : '1.0-1')
                        }}
                      </span>
                      <div
                        class="progress"
                        [ngStyle]="{
                          height: (budgetable.value.total_time_assigned_in_hours / budgetable.value.total_time_budget_in_hours) * 100 + '%',
                          'background-color': budgetable.value.progress_bar_color,
                        }"
                      ></div>
                    </div>
                    <div
                      class="budget"
                      [matTooltip]="
                        'Horas registradas en ' +
                        (castToWorkingTimeCategory(budgetable.value.distributable)?.short_name ?? budgetable.value.distributable.name)
                      "
                    >
                      <span>
                        {{
                          budgetable.value.total_time_done_in_hours
                            | number: (budgetable.value.total_time_done_in_hours > 1 ? '1.0-0' : '1.0-1')
                        }}
                      </span>
                      <div
                        class="progress"
                        [ngStyle]="{
                          height: (budgetable.value.total_time_done_in_hours / budgetable.value.total_time_budget_in_hours) * 100 + '%',
                          'background-color': budgetable.value.progress_bar_color,
                        }"
                      ></div>
                    </div>

                    @if (budgetable.value.total_time_assigned_in_seconds >= budgetable.value.total_time_budget_in_seconds) {
                      <mat-icon class="completed-check">check_circle</mat-icon>
                    }
                  </div>
                }
              </th>
              <td
                mat-cell
                *matCellDef="let task; let k = index"
                tabindex="0"
                (blur)="
                  item.value.company_product_phase_board
                    ? onBlur(
                        k,
                        $event,
                        'company_product_phase_boards',
                        'company_product_phase_board_' + item.value.company_product_phase_board.id,
                        'distributables',
                        budgetable.key,
                        'total_time_assigned_in_hours'
                      )
                    : onBlur(k, $event)
                "
                (focus)="onFocus(k, $event)"
                (keydown)="
                  item.value.company_product_phase_board
                    ? onKeydown(
                        k,
                        $event,
                        item.key + '_' + budgetable.key,
                        'company_product_phase_boards',
                        'company_product_phase_board_' + item.value.company_product_phase_board.id,
                        'distributables',
                        budgetable.key,
                        'total_time_assigned_in_hours'
                      )
                    : onKeydown(k, $event, item.key + '_' + budgetable.key)
                "
                [ngClass]="{
                  focusable: true,
                  'border-left': j === 0,
                  'roadmap-col': true,
                  'active-this-week': item.value.active_this_week,
                  'has-budget-in-sprint':
                    item.value.company_product_phase_board &&
                    task.company_product_phase_boards &&
                    task.company_product_phase_boards.hasOwnProperty(
                      'company_product_phase_board_' + item.value.company_product_phase_board.id
                    ) &&
                    task.company_product_phase_boards[
                      'company_product_phase_board_' + item.value.company_product_phase_board.id
                    ].distributables.hasOwnProperty(budgetable.key) &&
                    task.company_product_phase_boards['company_product_phase_board_' + item.value.company_product_phase_board.id]
                      .distributables[budgetable.key].total_time_assigned_in_hours > 0,
                  completed:
                    item.value.company_product_phase_board &&
                    task.company_product_phase_boards &&
                    task.company_product_phase_boards.hasOwnProperty(
                      'company_product_phase_board_' + item.value.company_product_phase_board.id
                    ) &&
                    task.company_product_phase_boards[
                      'company_product_phase_board_' + item.value.company_product_phase_board.id
                    ].distributables.hasOwnProperty(budgetable.key) &&
                    task.company_product_phase_boards['company_product_phase_board_' + item.value.company_product_phase_board.id]
                      .distributables[budgetable.key].completed_by_user_id !== null,
                  'has-prediction':
                    item.value.employee_calendar_register &&
                    task.future_sprint_reviews &&
                    task.future_sprint_reviews['employee_calendar_register_' + item.value.employee_calendar_register.id] &&
                    task.future_sprint_reviews['employee_calendar_register_' + item.value.employee_calendar_register.id]['distributables'][
                      budgetable.key
                    ],
                }"
              >
                <input
                  matInput
                  (dblclick)="
                    input.readOnly && input.value === ''
                      ? null
                      : (input.value = calculateMaxTimeValueRemainingToAssignInBoard(task.budgetables[budgetable.key]).toString())
                  "
                  (blur)="
                    item.value.company_product_phase_board
                      ? onBlur(
                          k,
                          $event,
                          'company_product_phase_boards',
                          'company_product_phase_board_' + item.value.company_product_phase_board.id,
                          'distributables',
                          budgetable.key,
                          'total_time_assigned_in_hours'
                        )
                      : onBlur(k, $event)
                  "
                  (focus)="onFocus(k, $event)"
                  [value]="
                    task.company_product_phase_boards['company_product_phase_board_' + item.value.company_product_phase_board?.id]
                      ?.distributables[budgetable.key]?.total_time_assigned_in_hours ??
                    (item.value.employee_calendar_register &&
                    task.future_sprint_reviews &&
                    task.future_sprint_reviews.hasOwnProperty('employee_calendar_register_' + item.value.employee_calendar_register.id) &&
                    task.future_sprint_reviews['employee_calendar_register_' + item.value.employee_calendar_register.id][
                      'distributables'
                    ].hasOwnProperty(budgetable.key)
                      ? task.future_sprint_reviews['employee_calendar_register_' + item.value.employee_calendar_register.id][
                          'distributables'
                        ][budgetable.key].total_time_assigned_in_hours
                      : null)
                  "
                  [readonly]="
                    !user_permissions().can_edit_board ||
                    task.completed ||
                    task.is_draft ||
                    task.is_archived ||
                    !item.value.is_present_or_future ||
                    item.value.company_product_phase_board === null ||
                    task.company_product_phase_boards['company_product_phase_board_' + item.value.company_product_phase_board?.id]
                      ?.distributables[budgetable.key]?.readonly
                  "
                  [type]="'number'"
                  [min]="0"
                  [step]="0.5"
                  #input
                />
                @if (
                  item.value.company_product_phase_board &&
                  task.company_product_phase_boards.hasOwnProperty(
                    'company_product_phase_board_' + item.value.company_product_phase_board.id
                  ) &&
                  task.company_product_phase_boards[
                    'company_product_phase_board_' + item.value.company_product_phase_board.id
                  ].distributables.hasOwnProperty(budgetable.key) &&
                  task.company_product_phase_boards['company_product_phase_board_' + item.value.company_product_phase_board.id]
                    .distributables[budgetable.key].completed_by_user_id !== null
                ) {
                  <mat-icon class="completed-check">check_circle</mat-icon>
                }
                @if (
                  item.value.company_product_phase_board &&
                  task.company_product_phase_boards.hasOwnProperty(
                    'company_product_phase_board_' + item.value.company_product_phase_board.id
                  ) &&
                  task.company_product_phase_boards[
                    'company_product_phase_board_' + item.value.company_product_phase_board.id
                  ].distributables.hasOwnProperty(budgetable.key) &&
                  task.company_product_phase_boards['company_product_phase_board_' + item.value.company_product_phase_board.id]
                    .distributables[budgetable.key].total_time_done_in_seconds > 0
                ) {
                  <span
                    class="progress-bar"
                    [ngStyle]="{
                      'background-color':
                        task.company_product_phase_boards['company_product_phase_board_' + item.value.company_product_phase_board.id]
                          .distributables[budgetable.key].total_time_done_in_seconds >
                          task.company_product_phase_boards['company_product_phase_board_' + item.value.company_product_phase_board.id]
                            .distributables[budgetable.key].total_time_assigned_in_seconds &&
                        task.company_product_phase_boards['company_product_phase_board_' + item.value.company_product_phase_board.id]
                          .distributables[budgetable.key].total_time_assigned_in_seconds > 0 &&
                        task.company_product_phase_boards['company_product_phase_board_' + item.value.company_product_phase_board.id]
                          .distributables[budgetable.key].total_time_done_in_seconds > 0
                          ? '#e86969'
                          : task.company_product_phase_boards['company_product_phase_board_' + item.value.company_product_phase_board.id]
                              .distributables[budgetable.key].background_soft_color,
                    }"
                  >
                    <span class="text">
                      {{
                        task.company_product_phase_boards['company_product_phase_board_' + item.value.company_product_phase_board.id]
                          .distributables[budgetable.key].total_time_done_in_hours | number: '1.0-2'
                      }}
                    </span>
                    <span
                      class="progress"
                      [ngStyle]="{
                        width:
                          (task.company_product_phase_boards['company_product_phase_board_' + item.value.company_product_phase_board.id]
                            .distributables[budgetable.key].total_time_done_in_seconds /
                            task.company_product_phase_boards['company_product_phase_board_' + item.value.company_product_phase_board.id]
                              .distributables[budgetable.key].total_time_assigned_in_seconds) *
                            100 +
                          '%',
                        'background-color':
                          task.company_product_phase_boards['company_product_phase_board_' + item.value.company_product_phase_board.id]
                            .distributables[budgetable.key].total_time_done_in_seconds >
                            task.company_product_phase_boards['company_product_phase_board_' + item.value.company_product_phase_board.id]
                              .distributables[budgetable.key].total_time_assigned_in_seconds &&
                          task.company_product_phase_boards['company_product_phase_board_' + item.value.company_product_phase_board.id]
                            .distributables[budgetable.key].total_time_assigned_in_seconds > 0 &&
                          task.company_product_phase_boards['company_product_phase_board_' + item.value.company_product_phase_board.id]
                            .distributables[budgetable.key].total_time_done_in_seconds > 0
                            ? '#e86969'
                            : task.company_product_phase_boards['company_product_phase_board_' + item.value.company_product_phase_board.id]
                                .distributables[budgetable.key].progress_bar_color,
                      }"
                    ></span>
                  </span>
                }
                @if (
                  item.value.company_product_phase_board &&
                  task.company_product_phase_boards.hasOwnProperty(
                    'company_product_phase_board_' + item.value.company_product_phase_board.id
                  ) &&
                  task.company_product_phase_boards[
                    'company_product_phase_board_' + item.value.company_product_phase_board.id
                  ].distributables.hasOwnProperty(budgetable.key)
                ) {
                  <button mat-icon-button class="setting-button" [matMenuTriggerFor]="menu">
                    <mat-icon>more_vert</mat-icon>
                  </button>
                  <mat-menu #menu="matMenu">
                    <button mat-menu-item (click)="openTask(k, item.value.company_product_phase_board.id)">
                      <mat-icon>visibility</mat-icon>
                      <span>Abrir tarea en tablero</span>
                    </button>
                    @if (item.value.is_present_or_future) {
                      <button
                        mat-menu-item
                        color="red"
                        (click)="deleteTaskDistributable(k, item.value.company_product_phase_board!, budgetable.key, item.key)"
                      >
                        <mat-icon>delete</mat-icon>
                        <span
                          >Eliminar
                          {{ castToWorkingTimeCategory(budgetable.value.distributable)?.short_name ?? budgetable.value.distributable.name }}
                          de la tarea</span
                        >
                      </button>
                      <button mat-menu-item color="red" (click)="deleteTaskFromBoard(k, item.value.company_product_phase_board!, item.key)">
                        <mat-icon>remove_circle</mat-icon>
                        <span>Eliminar tarea del board</span>
                      </button>
                    }
                  </mat-menu>
                }
              </td>
            </ng-container>
          }
        }

        <!-- ROWS -->
        @if (tab_selected === 'roadmap') {
          <tr mat-header-row class="head head1" *matHeaderRowDef="displayedColumns_extra_head1; sticky: true"></tr>
          <!-- Inicio board -->
          <tr mat-header-row class="head head2" *matHeaderRowDef="displayedColumns_extra_head2; sticky: true"></tr>
          <!-- Final board -->
          <tr mat-header-row class="head head3" *matHeaderRowDef="displayedColumns_extra_head3; sticky: true"></tr>
          <!-- Board name -->
        }
        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>

        <ng-template #addNewTaskRow let-i="i" let-position="position">
          <tr class="add-new-task-row">
            <td [attr.colspan]="displayedColumns.length" (click)="onAddNewRow(i, position)"></td>
          </tr>
        </ng-template>

        <!-- Main header -->
        <ng-template matNoDataRow>
          @if (user_permissions().can_create_tasks_on_backlog && (tab_selected !== 'roadmap' || !show_epics_only)) {
            <tr class="add-new-task-row">
              <td [attr.colspan]="displayedColumns.length" (click)="onAddNewRow(null, null)"></td>
            </tr>
          }
        </ng-template>

        <ng-container *matRowDef="let task; let i = index; columns: displayedColumns; trackBy: trackById">
          @if (task.is_first_epic) {
            <tr
              class="mat-mdc-row mdc-data-table__row cdk-row epic-separator-row"
              [ngClass]="{
                'epic-separator-row-epics-only': tab_selected === 'roadmap' && show_epics_only,
                'epic-separator-row-alt': tab_selected === 'roadmap' && show_epics_only && task.epic_row_is_even,
              }"
              [ngStyle]="{
                position: is_dragging ? 'static' : 'sticky',
                top: is_dragging ? null : (tab_selected === 'roadmap' ? 3 : 0) * 20 + 32 + 'px',
                'z-index': is_dragging ? null : '100',
              }"
              cdkDrag
              (cdkDragStarted)="onDragStarted()"
              (cdkDragEnded)="onDragEnded()"
              [cdkDragDisabled]="
                !user_permissions().can_edit_backlog || !task.company_product_epic_id || (tab_selected === 'roadmap' && show_epics_only)
              "
              [cdkDragData]="{
                type: 'epic',
                idx: i,
                epic: task.company_product_epic,
              }"
            >
              @if (tab_selected === 'roadmap' && show_epics_only) {
                <td
                  [style.padding]="'5px 0'"
                  [attr.colspan]="1"
                  class="mat-mdc-cell mdc-data-table__cell cdk-cell cdk-column-dragndrop mat-column-dragndrop"
                  [style.background-color]="null"
                ></td>
                <td
                  [style.padding]="'5px 0'"
                  [attr.colspan]="epic_title_colspan_for_epics_only"
                  class="epic-separator-title-cell"
                  [style.background-color]="null"
                >
                  <img [src]="'assets/img/icons/epic_icon.svg'" />
                  {{ task.company_product_epic?.name ?? 'Sin epic' }}
                </td>
                @for (roadmapItem of roadmap_columns_data | keyvalue; track roadmapItem.key) {
                  @for (
                    budgetable of roadmapItem.value.product_task_board_time_budgets | keyvalue;
                    track budgetable.key;
                    let budgetIdx = $index
                  ) {
                    <td
                      class="epic-separator-total-cell"
                      [style.background-color]="
                        (epic_roadmap_registered_hours[task.epic_group_key ?? 'no_epic__group_0']?.[
                          roadmapItem.key + '::' + budgetable.key
                        ] ?? 0) > 0
                          ? '#6DB5ED'
                          : roadmapItem.value.active_this_week
                            ? 'var(--accent-lighter-color, #ebf7ff)'
                            : null
                      "
                      [ngClass]="{
                        'border-left': budgetIdx === 0,
                        'roadmap-col': true,
                        'active-this-week': roadmapItem.value.active_this_week,
                      }"
                    >
                      {{
                        epic_roadmap_registered_hours[task.epic_group_key ?? 'no_epic__group_0']?.[
                          roadmapItem.key + '::' + budgetable.key
                        ] ?? 0 | number: '1.0-1'
                      }}
                    </td>
                  }
                }
                @if (epic_trailing_colspan_for_epics_only > 0) {
                  <td
                    [style.padding]="'5px 0'"
                    [attr.colspan]="epic_trailing_colspan_for_epics_only"
                    class="epic-separator-spacer-cell"
                    [style.background-color]="null"
                  ></td>
                }
              } @else {
                <td
                  [style.padding]="'5px 0'"
                  [attr.colspan]="1"
                  class="mat-mdc-cell mdc-data-table__cell cdk-cell cdk-column-dragndrop mat-column-dragndrop"
                >
                  @if (task.company_product_epic_id) {
                    <mat-icon style="cursor: grab; vertical-align: middle">drag_indicator</mat-icon>
                  }
                </td>
                <td [style.padding]="'5px 0'" [attr.colspan]="displayedColumns.length - 1">
                  <img [src]="'assets/img/icons/epic_icon.svg'" />
                  <span [matTooltip]="task.company_product_epic?.description ?? ''">
                    {{ task.company_product_epic?.name ?? 'Sin epic' }}
                  </span>
                </td>
              }

              <ng-template cdkDragPreview>
                <ng-container
                  *ngTemplateOutlet="epicDragPreviewTemplate; context: { epic: dataSource.data[i].company_product_epic }"
                ></ng-container>
              </ng-template>

              <ng-template cdkDragPlaceholder>
                <td class="custom-drag-drop-placeholder" [attr.colspan]="displayedColumns.length"></td>
              </ng-template>
            </tr>
          }
          @if ((tab_selected !== 'roadmap' || !show_epics_only) && user_permissions().can_edit_backlog) {
            <ng-container *ngTemplateOutlet="addNewTaskRow; context: { i: i, position: 'above' }"></ng-container>
          }
          <tr
            mat-row
            cdkDrag
            (cdkDragStarted)="onDragStarted()"
            (cdkDragEnded)="onDragEnded()"
            [cdkDragDisabled]="!task.can_edit"
            [cdkDragData]="{ type: 'task', idx: i, task: task }"
            class="row-number-{{ i }}"
            [attr.data-task-id]="task.id"
            [style.display]="tab_selected === 'roadmap' && show_epics_only ? 'none' : null"
            [ngClass]="{
              'new-task-row': !task.id,
              selected: task.selected,
              completed: task.completed,
              is_archived: task.is_archived,
              is_draft: task.is_draft,
              requires_client_approval: task.requires_client_approval,
              client_has_replied: task.client_has_approved !== null,
              client_has_approved: task.client_has_approved === true,
              client_has_declined: task.client_has_approved === false,
            }"
          >
            <ng-template cdkDragPreview>
              <div class="custom-drag-preview-container">
                @if (selected_task_idxs.length > 0) {
                  @for (idx of selected_task_idxs.slice(0, 3); track idx) {
                    <ng-container
                      *ngTemplateOutlet="taskDragPreviewTemplate; context: { i: idx, task: dataSource.data[idx] }"
                    ></ng-container>
                  }
                } @else {
                  <ng-container *ngTemplateOutlet="taskDragPreviewTemplate; context: { i: i, task: task }"></ng-container>
                }
              </div>
            </ng-template>

            <ng-template cdkDragPlaceholder>
              <td class="custom-drag-drop-placeholder" [attr.colspan]="displayedColumns.length"></td>
            </ng-template>
          </tr>
          @if (user_permissions().can_create_tasks_on_backlog && (tab_selected !== 'roadmap' || !show_epics_only)) {
            <ng-container *ngTemplateOutlet="addNewTaskRow; context: { i: i, position: 'below' }"></ng-container>
          }

          <ng-template #taskDragPreviewTemplate let-i="i" let-task="task">
            <div class="custom-drag-preview">
              <!-- Epic -->
              <span class="drag-preview-epic">
                <img [src]="'assets/img/icons/epic_icon.svg'" />
                {{ task.company_product_epic?.name ?? 'Sin Epic' }}
              </span>
              <!-- Type -->
              <span class="drag-preview-type" [ngClass]="task.type">
                <img [src]="task.type_image_url" />
                {{ task.type }}
              </span>
              <!-- Code -->
              <span class="drag-preview-code">{{ task.code }}</span>
              <!-- Title -->
              <span class="drag-preview-title">{{ task.title }}</span>
            </div>
          </ng-template>

          <ng-template #epicDragPreviewTemplate let-i="i" let-epic="epic">
            <div class="custom-drag-preview-epic">
              <!-- Epic -->
              <span class="drag-preview-epic">
                <img [src]="'assets/img/icons/epic_icon.svg'" />
                {{ epic.name ?? 'Sin Epic' }}
              </span>
            </div>
          </ng-template>
        </ng-container>
      </table>
    </div>
  </div>
</div>
